import { TResolution } from '../types';

const HOURLY: TResolution = 'hourly';
const DAILY: TResolution = 'daily';
const WEEKLY: TResolution = 'weekly';
const MONTHLY: TResolution = 'monthly';

export { HOURLY, DAILY, WEEKLY, MONTHLY };
